import React, {
  useCallback,
  useState,
  useMemo,
} from 'react';
import { InputProps } from './types/Input.types';
import clsx from 'clsx';

const RadioButton: React.FC<
  InputProps & React.InputHTMLAttributes<HTMLInputElement>
> = ({
  inputSize = 'medium',
  inputState = 'default',
  wrapperClassName,
  label,
  register,
  registerOptions,
  name,
  ...props
}) => {
    const [checked, setChecked] = useState<boolean>(
      props.checked ?? props.value == 'on'
    );
    const onChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange && props.onChange(e);
        setChecked(e.target.checked);
      },
      [props]
    );

    const sizeClass = useMemo(() => {
      switch (inputSize) {
        case 'small':
        case 'xsmall':
          return 'checkbox-wrapper--sm';
        case 'large':
          return 'checkbox-wrapper--lg';
        case 'xlarge':
          return 'checkbox-wrapper--xl';
        case 'medium':
        default:
          return 'checkbox-wrapper--md';
      }
    }, [inputSize]);

    return (
      <div
        className={clsx(
          wrapperClassName,
          'checkbox-wrapper',
          sizeClass
        )}
      >
        <label htmlFor={props.id}>
          {register && name ?
            <input
              type="radio"
              className="radio"
              {...props}
              {...register(name, registerOptions)}
              value={props.value}
            />
            :
            <input
              type="radio"
              className="radio"
              checked={checked}
              {...props}
              onChange={onChange}
            />
          }

          {label && <span>{label}</span>}
        </label>
      </div>
    );
  };

export default RadioButton;
